import { ChipProps } from '@mui/material';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, MutationDefinition } from '@reduxjs/toolkit/dist/query';
import { MutationTrigger } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { ETranscoderState, ETranscoderTaskKind } from '@vxui/common';

export * from './vod';
export * from './dictionary';
export * from './config';
export * from './event';

type ChipVariantState = { color: ChipProps['color']; label: string };

const stateVariants: { [key in ETranscoderState]: ChipVariantState } = {
  [ETranscoderState.idle]: { color: 'info', label: 'Idle' },
  [ETranscoderState.starting]: { color: 'success', label: 'Starting' },
  [ETranscoderState.started]: { color: 'success', label: 'Started' },
  [ETranscoderState.waiting]: { color: 'success', label: 'Waiting' },
  [ETranscoderState.running]: { color: 'success', label: 'Running' },
  [ETranscoderState.probing]: { color: 'success', label: 'Probing' },
  [ETranscoderState.stopping]: { color: 'success', label: 'Stopping' },
  [ETranscoderState.stopped]: { color: 'primary', label: 'Stopped' },
  [ETranscoderState.completed]: { color: 'success', label: 'Completed' },
  [ETranscoderState.readytostart]: { color: 'warning', label: 'Ready To Start' },
  [ETranscoderState.failed]: { color: 'error', label: 'Failed' },
  [ETranscoderState.restarting]: { color: 'success', label: 'Restarting' },
};

export const getStateVariant = (state?: ETranscoderState | keyof typeof ETranscoderState): ChipVariantState => {
  const defaultVariant: ChipVariantState = { color: 'error', label: 'Error state' };

  if (!state) {
    return stateVariants[ETranscoderState.readytostart];
  }

  if (typeof state === 'string') {
    const transcoderState: ETranscoderState = ETranscoderState[state];
    return stateVariants[transcoderState] || defaultVariant;
  }
  return stateVariants[ETranscoderState[state]];
};

export type CoreRoutesProps = {
  // eslint-disable-next-line
  taskApi?: any;
  taskKind: ETranscoderTaskKind;
};

export type TMutationTrigger = MutationTrigger<
  MutationDefinition<
    // eslint-disable-next-line
    any,
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, Record<string, never>, Record<string, never>>,
    string,
    // eslint-disable-next-line
    any,
    string
  >
>;
